module.exports = __webpack_public_path__ + "img/recreate-smash.78ca0848.png";